import { Stack, Typography } from '@mui/material';
import { PaymentComponent } from 'components';
import { PopupThankYouPurchase } from 'features/credits/components';
import { useQueryString } from 'hooks';
import { PURCHASED_PACKAGE_FROM } from 'models/credits';
import { PAYMENT_METHOD, PAYMENT_STATUS, PAYMENT_TYPE } from 'models/payments';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'routers/routes';
import { useAppDispatch, useAppSelector } from 'store/hook';
import {
  setOpenPaymentSuccess,
  updateStatusPayNow,
} from 'store/reducers/payments';
import {
  checkoutPurchasePackageAction,
  payForBuyPackageAction,
} from 'store/reducers/payments/actionTypes';
import { formatPrice, pluralString } from 'utils';

export const PaymentCredits = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const query = useQueryString();
  const { openPaymentSuccess, paymentMethodId } = useAppSelector(
    (state) => state.payment,
  );
  const { idPackSelected, packageList } = useAppSelector(
    (state) => state.credits,
  );

  const packageSelected = packageList.find((item) =>
    item.id.includes(idPackSelected),
  );

  const prevUrlJob = query.type === PURCHASED_PACKAGE_FROM.JOB;

  const handleBackAction = () => {
    if (prevUrlJob) {
      navigate(-1);
    } else navigate(APP_ROUTES.CREDITS.OVERVIEW.to);
  };

  const getEnhancedPlan = () => {
    if (packageSelected) {
      return +(packageSelected.price / packageSelected.parent_rate).toFixed();
    }
  };

  const paymentCallback = (isPayNow: boolean, callback?: Function) => {
    const _params = {
      payment_method_id: !isPayNow ? paymentMethodId : undefined,
      payment_method_type: isPayNow
        ? PAYMENT_METHOD.PAY_NOW
        : PAYMENT_METHOD.CARD,
      package_id: idPackSelected,
    };

    dispatch(
      payForBuyPackageAction({
        data: _params,
        onSuccess: (qrCode: string) => {
          dispatch(updateStatusPayNow(PAYMENT_STATUS.SUCCESS));
          if (isPayNow) {
            callback?.(qrCode);
            return;
          }
          dispatch(setOpenPaymentSuccess(true));
        },
        onFailed: () => {
          dispatch(updateStatusPayNow(PAYMENT_STATUS.FAILED));
        },
        onFinally: () => {},
      }),
    );
  };

  const checkoutAction = (isPayNow: boolean) => {
    if (!packageSelected) {
      navigate(APP_ROUTES.CREDITS.BUY_PACKAGE.to);
      return;
    }
    dispatch(
      checkoutPurchasePackageAction({
        data: {
          package_id: packageSelected.id,
          payment_method_type: isPayNow
            ? PAYMENT_METHOD.PAY_NOW
            : PAYMENT_METHOD.CARD,
        },
        onFailed: () => {
          handleBackAction();
        },
      }),
    );
  };

  return (
    <Stack spacing={8}>
      {openPaymentSuccess && (
        // <PopupConfirm
        //   typeIcon={TYPE_ICON.CHECK}
        //   title={SYS_MESS.SUCCESS.PAYMENT}
        //   content={
        //     <Typography variant="Web_Label_14">
        //       Your payment has been successfully made
        //     </Typography>
        //   }
        //   textButton={`Back to ${prevUrlJob ? 'Bookings' : 'Credits'}`}
        //   hrefButton={prevUrlJob ? -1 : APP_ROUTES.CREDITS.OVERVIEW.to}
        //   justCloseWithBtn
        //   handleClose={() => {
        //     dispatch(setOpenPaymentSuccess(false));
        //   }}
        // />
        <PopupThankYouPurchase
          onClose={() => dispatch(setOpenPaymentSuccess(false))}
        />
      )}
      <Stack spacing={1} alignItems="center">
        <Typography variant="Web_Title_22">Payment</Typography>
        <Typography variant="Web_Label_18">Buy Sitter Plan</Typography>
      </Stack>
      <PaymentComponent
        basicFees={
          <Stack>
            <Typography variant="Components_Column_content" color={'#6d6d6d'}>
              Enhanced Plan - {pluralString('hour', getEnhancedPlan())}
            </Typography>
            <Typography variant="Components_Column_content" color={'#6d6d6d'}>
              {formatPrice(packageSelected?.price)}
            </Typography>
          </Stack>
        }
        paymentType={PAYMENT_TYPE.PURCHASE_PACKAGE}
        checkoutAction={checkoutAction}
        paymentCallback={paymentCallback}
        handleBackAction={handleBackAction}
      />
    </Stack>
  );
};

export default PaymentCredits;
